import { m as motion } from "framer-motion";

export default function NumberedChapter({ number, title, children, tone = "ivory", index = 0 }) {
  const num = String(number).padStart(2, "0");
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.9, delay: index * 0.08, ease: [0.19, 1, 0.22, 1] }}
      className="grid grid-cols-12 gap-6 py-10 border-t border-[var(--line)]"
      data-testid={`chapter-${num}`}
    >
      <div className="col-span-12 md:col-span-2">
        <div className="chapter-num">{num}</div>
      </div>
      <div className="col-span-12 md:col-span-4">
        <h3 className="font-display text-3xl md:text-4xl leading-tight text-[var(--ink)]">{title}</h3>
      </div>
      <div className="col-span-12 md:col-span-6 text-[15px] leading-relaxed text-[var(--brown)]/85 max-w-lg">
        {children}
      </div>
    </motion.div>
  );
}
